module.exports = __webpack_public_path__ + "img/2015.e080f1c5.jpg";